/* eslint-disable */
module.exports = {
  init() {
    window.ga =
      window.ga ||
      function() {
        (ga.q = ga.q || []).push(arguments);
      };
    ga.l = +new Date();
    ga('create', 'UA-57453406-1', 'auto');
    ga('send', 'pageview');
  }
};
